import { render, staticRenderFns } from "./Infoscreen.vue?vue&type=template&id=2c6cb5e6&scoped=true&"
import script from "./Infoscreen.vue?vue&type=script&lang=js&"
export * from "./Infoscreen.vue?vue&type=script&lang=js&"
import style0 from "./Infoscreen.vue?vue&type=style&index=0&id=2c6cb5e6&lang=scss&scoped=true&"
import style1 from "./Infoscreen.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6cb5e6",
  null
  
)

export default component.exports